import { RootState } from "@/app/store"

import zh from "@/app/i18n/zh.json"
import en from "@/app/i18n/en.json"
// import cn from "@/app/i18n/cn.json"
export type Lang = "zh" | "en" // | "cn"

const dict: { [k in Lang]: { [key: string]: string } } = {
  zh,
  en,
  // cn,
}

export const availableLang: { code: Lang; display: string }[] = [
  {
    code: "zh",
    display: "繁",
  },
  {
    code: "en",
    display: "Eng",
  },
  // {
  //   code: "cn",
  //   display: "简",
  // },
]
type Replace = { [key: string]: string }

export const useTranslate = () => {
  const lang = useAppSelector((state: RootState) => state.app.lang)
  return (key: string, replace?: Replace) => {
    let translated = dict[lang][key]

    if (!translated) {
      console.warn(`Translation of ${key} for language ${lang} not found!`)
      return key
    }
    if (replace) {
      const validReplaceKeys = Object.keys(replace).filter((k) =>
        translated.includes(`{{${k}}}`),
      )
      for (const k of validReplaceKeys) {
        translated = translated.replace(new RegExp(`{{${k}}}`, "g"), replace[k])
      }
    }

    return translated
  }
}

export const useTranslateExist = () => {
  const lang = useAppSelector((state: RootState) => state.app.lang)
  return (key: string) => {
    return !!dict[lang][key]
  }
}
